import { Request } from '../request';
import type {
    ProviderCustomRecurrenceRuleReq,
    ProviderCustomRecurrenceRuleVo,
    ProviderRecurrenceServiceSeriesReq,
    ProviderRecurrenceServiceSeriesUpdateReq,
    ProviderRecurrenceServiceSeriesVo,
} from './types';

export type { ProviderCustomRecurrenceRuleReq, ProviderCustomRecurrenceRuleVo } from './types';
export type {
    ProviderRecurrenceServiceSeriesReq,
    ProviderRecurrenceServiceSeriesUpdateReq,
    ProviderRecurrenceServiceSeriesVo,
    ProviderRecurrenceType,
} from './types';

export const createProviderCustomRecurrenceRule = (params: ProviderCustomRecurrenceRuleReq) =>
    Request.post({
        url: '/schedule-server/provider/recurrence/custom-rule/create',
        params,
    });

export const listProviderCustomRecurrenceRules = () =>
    Request.get<ProviderCustomRecurrenceRuleVo[]>({
        url: '/schedule-server/provider/recurrence/custom-rule/list',
        disableErrorNote: true,
    });

export const createProviderRecurrenceServiceSeries = (params: ProviderRecurrenceServiceSeriesReq, overrideProviderId?: number) =>
    Request.post<ProviderRecurrenceServiceSeriesVo>({
        url: '/schedule-server/provider/recurrence/service-series/create',
        params,
        disableErrorNote: true,
        overrideProviderId,
    });

export const updateProviderRecurrenceServiceSeries = (params: ProviderRecurrenceServiceSeriesUpdateReq, overrideProviderId?: number | string) =>
    Request.post<ProviderRecurrenceServiceSeriesVo>({
        url: '/schedule-server/provider/recurrence/service-series/update',
        params,
        disableErrorNote: true,
        overrideProviderId,
    });

export const getProviderRecurrenceServiceSeriesDetail = (params: { id: number }, overrideProviderId?: number | string) =>
    Request.get<ProviderRecurrenceServiceSeriesVo>({
        url: '/schedule-server/provider/recurrence/service-series/detail',
        params,
        disableErrorNote: true,
        overrideProviderId,
    });
